module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-60x60-9ffb1de07491cbde5e1b76166c906c56.png";